export const ATOMIC_ROLE_PREFIX = "Atomic:";
export const TENANT_ID_HEADER = "tenant-id";
